import {
    TEQTANK_COMMERCE_CONTRACT_VERSION,
    type CommerceSdkIdentity,
} from "@teqtank/commerce-contracts";

export type {
    BootstrapCommerceContextRequest,
    BootstrapCommerceContextResponse,
    BootstrapCommerceSessionRequest,
    BootstrapCommerceSessionResponse,
    AddCommerceCartLineRequest,
    AddCommerceCartLineResponse,
    ApplyCommerceCartCouponRequest,
    ApplyCommerceCartCouponResponse,
    ClearCommerceCartRequest,
    ClearCommerceCartResponse,
    Commerce,
    CommerceShareAcceptanceStrategy,
    CommerceSharePreview,
    CommerceConfiguration,
    CommerceDataSource,
    CommerceCustomer,
    CommerceCustomerChangeReason,
    CommerceCustomerChangedEvent,
    CommerceCustomerChangedListener,
    CommerceCustomerDomain,
    CommerceCustomerSession,
    CommerceCustomerSessionStatus,
    CommerceCustomerAction,
    GetCommerceCustomerActionsRequest,
    GetCommerceCustomerActionsResponse,
    LaunchCommerceCustomerActionRequest,
    LaunchCommerceCustomerActionResponse,
    BeginCommerceEnrollmentRequest,
    BeginCommerceEnrollmentResponse,
    CommerceEnrollmentCart,
    CommerceEnrollmentCartLine,
    CommerceEnrollmentChangeReason,
    CommerceEnrollmentChangedEvent,
    CommerceEnrollmentChangedListener,
    CommerceEnrollmentDomain,
    CommerceEnrollmentEligibility,
    CommerceEnrollmentKit,
    CommerceEnrollmentProgress,
    CommerceEnrollmentSession,
    CommerceEnrollmentStage,
    CommerceEnrollmentStageKind,
    CommerceEnrollmentStagePresentation,
    GetCommerceEnrollmentRequest,
    GetCommerceEnrollmentResponse,
    SelectCommerceEnrollmentKitRequest,
    SelectCommerceEnrollmentKitResponse,
    AddCommerceEnrollmentProductRequest,
    AddCommerceEnrollmentProductResponse,
    CompleteCommerceEnrollmentStageRequest,
    CompleteCommerceEnrollmentStageResponse,
    ReturnCommerceEnrollmentToShoppingRequest,
    ReturnCommerceEnrollmentToShoppingResponse,
    AbandonCommerceEnrollmentRequest,
    AbandonCommerceEnrollmentResponse,
    CommerceCart,
    CommerceCartChangeReason,
    CommerceCartChangedEvent,
    CommerceCartChangedListener,
    CommerceCartCoupon,
    CommerceCartDomain,
    CommerceCartLine,
    CommerceCartPurchaseType,
    CommerceCartTotals,
    CommerceContext,
    CommerceContextChangedEvent,
    CommerceContextChangedListener,
    CommerceCountryOption,
    CommerceCurrencyOption,
    CommerceCurrencyContext,
    CommerceDisposedEvent,
    CommerceDisposedListener,
    CommerceErrorCode,
    CommerceEvent,
    CommerceEventListener,
    CommerceEventName,
    CommerceEventOf,
    CommerceEventsDomain,
    CommerceEventUnsubscribe,
    CommerceNamedEventListener,
    CommerceFeature,
    CommerceFeatureSet,
    CommerceImage,
    CommerceLifecycle,
    CommerceLocaleContext,
    CommerceMarketContext,
    CommerceMarketDomain,
    CommerceMarketSwitchResult,
    CommerceMoney,
    CommerceOperationInvocation,
    CommerceOperationMiddleware,
    CommerceOperationNext,
    CommerceOperationOptions,
    SwitchCommerceMarketRequest,
    SwitchCommerceMarketResponse,
    CommerceOrder,
    CommerceOrderChangeReason,
    CommerceOrderChangedEvent,
    CommerceOrderChangedListener,
    CommerceOrderDomain,
    CommerceOrderItem,
    CommerceOrderStatus,
    CommerceOrderTotals,
    CommerceOrderWaitOptions,
    CommerceReceipt,
    CommerceShipment,
    GetCommerceOrderRequest,
    GetCommerceOrderResponse,
    LoginCommerceCustomerRequest,
    LoginCommerceCustomerResponse,
    RequestCommerceCustomerVerificationCodeRequest,
    RequestCommerceCustomerVerificationCodeResponse,
    VerifyCommerceCustomerCodeRequest,
    VerifyCommerceCustomerCodeResponse,
    CommerceSavedPaymentMethod,
    LogoutCommerceCustomerRequest,
    LogoutCommerceCustomerResponse,
    RefreshCommerceCustomerSessionRequest,
    RefreshCommerceCustomerSessionResponse,
    RefreshCommerceOrderRequest,
    RefreshCommerceOrderResponse,
    CommercePaymentAdapter,
    CommercePaymentAdapterEventName,
    CommercePaymentAdapterListener,
    CommercePaymentAdapterResult,
    CommercePaymentChangeReason,
    CommercePaymentChangedEvent,
    CommercePaymentChangedListener,
    CommercePaymentDomain,
    CommercePaymentOrder,
    CommercePaymentResult,
    CommercePaymentState,
    CommercePaymentStatus,
    CommercePageRequest,
    CommercePageResult,
    CommerceProduct,
    CommerceProductComponent,
    CommerceProductCatalogue,
    CommerceProductCategory,
    CommerceProductOptionGroup,
    CommerceProductOptionValue,
    CommercePrice,
    CommercePurchaseOffer,
    CommerceRecurringFrequency,
    CommerceRecurringFrequencyOption,
    CommerceRecurringFrequencyUnit,
    CommerceProductSort,
    CommerceProductStatus,
    CommerceProductSummary,
    CommerceProductType,
    CommerceProductIdentity,
    CommerceProductLookup,
    CommerceProductDetailConfiguration,
    ResolvedCommerceProductDetailConfiguration,
    CommerceProductVariant,
    CommerceProductVariantSelection,
    CommerceRuntimeDiagnostics,
    CommerceRuntimeInitializationStage,
    CommerceRuntimeInitializationStageName,
    CommerceSession,
    CommerceStorefrontContext,
    CommerceStorefrontAliasResolver,
    CommerceStorefrontConfiguration,
    ResolvedCommerceStorefrontConfiguration,
    CommerceContactMethods,
    CommerceStorefrontContact,
    CommerceStorefrontLocation,
    CommerceStorefrontStatus,
    CommerceAttribution,
    CommerceBuiltInShareChannel,
    CommerceShareChannel,
    CommerceShareDomain,
    CommerceShareEvent,
    CommerceShareEventName,
    CommerceShareListener,
    CommerceShareProvider,
    CommerceShareResource,
    CommerceShareTarget,
    CommerceShareTargetType,
    CommerceStorefrontChangeReason,
    CommerceStorefrontChangedEvent,
    CommerceStorefrontChangedListener,
    CommerceStorefrontDomain,
    CommerceStorefrontExperience,
    CreateCommerceShareResourceRequest,
    CreateCommerceShareResourceResponse,
    ResolveCommerceStorefrontRequest,
    ResolveCommerceStorefrontResponse,
    ClearCommerceStorefrontRequest,
    ClearCommerceStorefrontResponse,
    CommerceTenantContext,
    GetCommerceCartRequest,
    GetCommerceCartResponse,
    GetCommerceProductCategoriesRequest,
    GetCommerceProductCategoriesResponse,
    GetCommerceProductCategoryRequest,
    GetCommerceProductCategoryResponse,
    GetCommerceProductRequest,
    GetCommerceProductResponse,
    RemoveCommerceCartCouponRequest,
    RemoveCommerceCartCouponResponse,
    RemoveCommerceCartLineRequest,
    RemoveCommerceCartLineResponse,
    ResolvedCommerceConfiguration,
    SearchCommerceProductsRequest,
    SearchCommerceProductsResponse,
    UpdateCommerceCartLineQuantityRequest,
    UpdateCommerceCartLineQuantityResponse,
    BeginCommerceCheckoutRequest,
    BeginCommerceQuickBuyRequest,
    BeginCommerceQuickBuyResponse,
    ClearCommerceCheckoutCustomerDetailsRequest,
    ClearCommerceCheckoutCustomerDetailsResponse,
    BeginCommerceCheckoutResponse,
    ApplyCommerceCheckoutCustomerRequest,
    ApplyCommerceCheckoutCustomerResponse,
    SelectCommerceCheckoutSavedPaymentMethodRequest,
    SelectCommerceCheckoutSavedPaymentMethodResponse,
    CommerceCheckoutPaymentConfiguration,
    CommerceCheckoutPaymentOption,
    CommerceCheckoutPoints,
    GetCommerceCheckoutPaymentConfigurationRequest,
    GetCommerceCheckoutPaymentConfigurationResponse,
    SelectCommerceCheckoutPaymentOptionRequest,
    SelectCommerceCheckoutPaymentOptionResponse,
    ApplyCommerceCheckoutPointsRequest,
    ApplyCommerceCheckoutPointsResponse,
    CalculateCommerceCheckoutRequest,
    CalculateCommerceCheckoutResponse,
    CommerceAddress,
    CommerceAddressRegion,
    GetCommerceAddressRegionsRequest,
    GetCommerceAddressRegionsResponse,
    CommerceCheckout,
    CommerceCheckoutExperience,
    CommerceCheckoutChangeReason,
    CommerceCheckoutChangedEvent,
    CommerceCheckoutChangedListener,
    CommerceCheckoutContact,
    CommerceCustomerAddress,
    CommerceCustomerIdentityField,
    CommerceCustomerIdentityStatus,
    ResolveCommerceCustomerIdentityRequest,
    ResolveCommerceCustomerIdentityResponse,
    CreateCommerceCustomerRequest,
    CreateCommerceCustomerResponse,
    CommerceCustomerRegistrationConfiguration,
    CommerceCustomerRegistrationSponsor,
    CommerceCustomerRegistrationVerification,
    CommerceCustomerRegistrationConsent,
    CommerceCustomerSponsor,
    CommerceCustomerSponsorSelection,
    CommerceCustomerVerification,
    CommerceCustomerConsentSelection,
    GetCommerceCustomerRegistrationRequest,
    GetCommerceCustomerRegistrationResponse,
    SearchCommerceCustomerSponsorsRequest,
    SearchCommerceCustomerSponsorsResponse,
    CommerceCheckoutDomain,
    CommerceCheckoutUpsell,
    CommerceCheckoutUpsellChoice,
    RespondCommerceCheckoutUpsellRequest,
    RespondCommerceCheckoutUpsellResponse,
    UpdateCommerceCheckoutItemPurchaseRequest,
    UpdateCommerceCheckoutItemPurchaseResponse,
    CommerceCheckoutItem,
    CommerceCheckoutItemSource,
    CommerceCheckoutStatus,
    CommerceCheckoutTotals,
    CommerceCheckoutValidation,
    CommerceCheckoutValidationMessage,
    CommerceCheckoutValidationSeverity,
    CommerceShippingMethod,
    GetCommerceCheckoutRequest,
    GetCommerceCheckoutResponse,
    SelectCommerceCheckoutShippingMethodRequest,
    SelectCommerceCheckoutShippingMethodResponse,
    SubmitCommerceCheckoutRequest,
    SubmitCommerceCheckoutResponse,
    CompleteCommerceCheckoutRequest,
    CompleteCommerceCheckoutResponse,
    SubmitCommercePaymentOrderRequest,
    UpdateCommerceCheckoutAddressRequest,
    UpdateCommerceCheckoutAddressResponse,
    UpdateCommerceCheckoutContactRequest,
    UpdateCommerceCheckoutContactResponse,
} from "@teqtank/commerce-contracts";

export { CommerceError } from "./errors/commerce-error.js";

export { addCommerceCartLineOperation } from "./operations/add-commerce-cart-line-operation.js";
export { applyCommerceCartCouponOperation } from "./operations/apply-commerce-cart-coupon-operation.js";
export { clearCommerceCartOperation } from "./operations/clear-commerce-cart-operation.js";
export { getCommerceCartOperation } from "./operations/get-commerce-cart-operation.js";
export { removeCommerceCartCouponOperation } from "./operations/remove-commerce-cart-coupon-operation.js";
export { removeCommerceCartLineOperation } from "./operations/remove-commerce-cart-line-operation.js";
export { updateCommerceCartLineQuantityOperation } from "./operations/update-commerce-cart-line-quantity-operation.js";

export { bootstrapCommerceContextOperation } from "./operations/bootstrap-commerce-context-operation.js";
export { switchCommerceMarketOperation } from "./operations/switch-commerce-market-operation.js";

export { bootstrapCommerceSessionOperation } from "./operations/bootstrap-commerce-session-operation.js";

export { getCommerceProductCategoriesOperation } from "./operations/get-commerce-product-categories-operation.js";

export { getCommerceProductCategoryOperation } from "./operations/get-commerce-product-category-operation.js";

export { getCommerceProductOperation } from "./operations/get-commerce-product-operation.js";

export { searchCommerceProductsOperation } from "./operations/search-commerce-products-operation.js";

export { beginCommerceCheckoutOperation } from "./operations/begin-commerce-checkout-operation.js";
export { beginCommerceQuickBuyOperation } from "./operations/begin-commerce-quick-buy-operation.js";
export { clearCommerceCheckoutCustomerDetailsOperation } from "./operations/clear-commerce-checkout-customer-details-operation.js";
export { calculateCommerceCheckoutOperation } from "./operations/calculate-commerce-checkout-operation.js";
export { applyCommerceCheckoutPointsOperation } from "./operations/apply-commerce-checkout-points-operation.js";
export { getCommerceCheckoutPaymentConfigurationOperation } from "./operations/get-commerce-checkout-payment-configuration-operation.js";
export { getCommerceAddressRegionsOperation } from "./operations/get-commerce-address-regions-operation.js";
export { getCommerceCheckoutOperation } from "./operations/get-commerce-checkout-operation.js";
export { selectCommerceCheckoutShippingMethodOperation } from "./operations/select-commerce-checkout-shipping-method-operation.js";
export { submitCommerceCheckoutOperation } from "./operations/submit-commerce-checkout-operation.js";
export { updateCommerceCheckoutAddressOperation } from "./operations/update-commerce-checkout-address-operation.js";
export { updateCommerceCheckoutContactOperation } from "./operations/update-commerce-checkout-contact-operation.js";

export { getCommerceOrderOperation } from "./operations/get-commerce-order-operation.js";
export { refreshCommerceOrderOperation } from "./operations/refresh-commerce-order-operation.js";
export { createCommerceCustomerOperation } from "./operations/create-commerce-customer-operation.js";
export { resolveCommerceCustomerIdentityOperation } from "./operations/resolve-commerce-customer-identity-operation.js";
export { loginCommerceCustomerOperation } from "./operations/login-commerce-customer-operation.js";
export { logoutCommerceCustomerOperation } from "./operations/logout-commerce-customer-operation.js";
export { refreshCommerceCustomerSessionOperation } from "./operations/refresh-commerce-customer-session-operation.js";
export { getCommerceCustomerActionsOperation } from "./operations/get-commerce-customer-actions-operation.js";
export { launchCommerceCustomerActionOperation } from "./operations/launch-commerce-customer-action-operation.js";

export { TeqtankCommerce, createCommerce } from "./teqtank-commerce.js";
export type { PersistedCommerceSessionTarget } from "./session/browser-commerce-session.js";
export { clearPersistedCommerceSession } from "./session/browser-commerce-session.js";

export { TEQTANK_COMMERCE_SDK_VERSION } from "./version.js";

export function getCommerceSdkIdentity(): CommerceSdkIdentity {
    return {
        name: "Teqtank Commerce SDK",
        contractVersion: TEQTANK_COMMERCE_CONTRACT_VERSION,
    };
}
export { beginCommerceEnrollmentOperation } from "./operations/begin-commerce-enrollment-operation.js";
export { getCommerceEnrollmentOperation } from "./operations/get-commerce-enrollment-operation.js";
export { selectCommerceEnrollmentKitOperation } from "./operations/select-commerce-enrollment-kit-operation.js";
export { addCommerceEnrollmentProductOperation } from "./operations/add-commerce-enrollment-product-operation.js";
export { returnCommerceEnrollmentToShoppingOperation } from "./operations/return-commerce-enrollment-to-shopping-operation.js";
export { completeCommerceEnrollmentStageOperation } from "./operations/complete-commerce-enrollment-stage-operation.js";
export { abandonCommerceEnrollmentOperation } from "./operations/abandon-commerce-enrollment-operation.js";

export { resolveCommerceStorefrontOperation } from "./operations/resolve-commerce-storefront-operation.js";
export { clearCommerceStorefrontOperation } from "./operations/clear-commerce-storefront-operation.js";
export {
    createPathStorefrontAliasResolver,
    createQueryStorefrontAliasResolver,
    createSubdomainStorefrontAliasResolver,
    type PathStorefrontAliasResolverOptions,
    type SubdomainStorefrontAliasResolverOptions,
} from "./storefront/commerce-storefront-routing.js";
export { createCommerceShareResourceOperation } from "./operations/create-commerce-share-resource-operation.js";
export { resolveCommerceShareOperation } from "./operations/resolve-commerce-share-operation.js";
export { acceptCommerceShareOperation } from "./operations/accept-commerce-share-operation.js";

export { respondCommerceCheckoutUpsellOperation } from "./operations/respond-commerce-checkout-upsell-operation.js";
export { updateCommerceCheckoutItemPurchaseOperation } from "./operations/update-commerce-checkout-item-purchase-operation.js";

export { requestCommerceCustomerVerificationCodeOperation } from "./operations/request-commerce-customer-verification-code-operation.js";
export { verifyCommerceCustomerCodeOperation } from "./operations/verify-commerce-customer-code-operation.js";
export { applyCommerceCheckoutCustomerOperation } from "./operations/apply-commerce-checkout-customer-operation.js";
export { selectCommerceCheckoutSavedPaymentMethodOperation } from "./operations/select-commerce-checkout-saved-payment-method-operation.js";
export { selectCommerceCheckoutPaymentOptionOperation } from "./operations/select-commerce-checkout-payment-option-operation.js";
